import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, Rectangle, Typography } from '@pitchero/react-ui';
import Icon from '../icon';
import ClubLink from '../club-link';

const ClearFilterButton = ({ label, route, params }) => (
  <Cushion bottom="small" component="div">
    <Rectangle radius="rounded" fill="mercury" style={{ display: 'inline-block' }}>
      <Cushion horizontal={8} vertical={6} component="div" style={{ display: 'inline-block' }}>
        <ClubLink route={route} params={params}>
          <a>
            <Typography preset="name" color="black">
              {label}
            </Typography>
          </a>
        </ClubLink>
      </Cushion>
      <Rectangle radius="0 4px 4px 0" fill="alto" style={{ display: 'inline-block' }}>
        <Cushion all={6} component="div">
          <ClubLink route={route} params={params}>
            <a>
              <Icon name="cross" preset="name" color="black" />
            </a>
          </ClubLink>
        </Cushion>
      </Rectangle>
    </Rectangle>
  </Cushion>
);

ClearFilterButton.defaultProps = {
  params: {},
};

ClearFilterButton.propTypes = {
  label: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  params: PropTypes.shape(),
};

export default ClearFilterButton;
